module.exports = __webpack_public_path__ + "img/p4.5c3985c7.png";